/**
 * Account settings page
 * Allows users to manage their account settings and change password
 */

import { getApiUrl } from './apiConfig.js';

let currentUser: any = null;

// Initialize settings page
async function init() {
    // Check authentication
    const authenticated = await checkAuth();
    if (!authenticated) {
        window.location.href = '/login.html';
        return;
    }

    // Load user info
    displayUserInfo();

    // Setup form handlers
    setupPasswordForm();
}

// Check if user is authenticated
async function checkAuth(): Promise<boolean> {
    try {
        const response = await fetch(getApiUrl('/auth/user'), {
            credentials: 'include'
        });

        if (!response.ok) {
            return false;
        }

        const data = await response.json();
        currentUser = data.user;
        return true;
    } catch (error) {
        console.error('Auth check failed:', error);
        return false;
    }
}

// Display user information
function displayUserInfo() {
    const emailEl = document.getElementById('user-email')!;
    const nameEl = document.getElementById('user-name')!;
    const typeEl = document.getElementById('user-type')!;
    const passwordSection = document.getElementById('password-section')!;
    const googleNotice = document.getElementById('google-notice')!;

    emailEl.textContent = currentUser.email;
    nameEl.textContent = currentUser.name || 'Not set';
    
    // Determine account type
    if (currentUser.google_id && !currentUser.password_hash) {
        typeEl.textContent = 'Google Account';
        passwordSection.classList.add('hidden');
        googleNotice.classList.remove('hidden');
    } else if (currentUser.google_id && currentUser.password_hash) {
        typeEl.textContent = 'Google + Password';
    } else {
        typeEl.textContent = 'Email/Password';
    }
}

// Setup password change form
function setupPasswordForm() {
    const form = document.getElementById('change-password-form') as HTMLFormElement;
    if (!form) return;

    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        
        const currentPassword = (document.getElementById('current-password') as HTMLInputElement).value;
        const newPassword = (document.getElementById('new-password') as HTMLInputElement).value;
        const confirmPassword = (document.getElementById('confirm-password') as HTMLInputElement).value;
        
        const errorEl = document.getElementById('password-error')!;
        const successEl = document.getElementById('password-success')!;
        
        // Hide previous messages
        errorEl.classList.add('hidden');
        successEl.classList.add('hidden');
        
        // Validate passwords match
        if (newPassword !== confirmPassword) {
            errorEl.textContent = 'New passwords do not match';
            errorEl.classList.remove('hidden');
            return;
        }
        
        // Validate password length (minimum 8 characters per OWASP guidelines)
        if (newPassword.length < 8) {
            errorEl.textContent = 'Password must be at least 8 characters';
            errorEl.classList.remove('hidden');
            return;
        }
        
        try {
            const response = await fetch(getApiUrl('/auth/change-password'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    currentPassword,
                    newPassword
                })
            });
            
            const data = await response.json();
            
            if (!response.ok) {
                errorEl.textContent = data.error || 'Failed to change password';
                errorEl.classList.remove('hidden');
                return;
            }
            
            // Success
            successEl.textContent = 'Password changed successfully';
            successEl.classList.remove('hidden');
            
            // Clear form
            form.reset();
            
        } catch (error) {
            console.error('Password change failed:', error);
            errorEl.textContent = 'An error occurred. Please try again.';
            errorEl.classList.remove('hidden');
        }
    });
}

// Initialize on load
document.addEventListener('DOMContentLoaded', init);
